

export const placesStore=[

    {
        id:"1",
        homeMainPic: "https://a0.muscache.com/im/pictures/e25a9b25-fa98-4160-bfd1-039287bf38b6.jpg?im_w=720",
        name:"Abiansemal",
        price: 500,
        type:"tropical",
        stars: "4.88",
        carouselPic1: "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/f4f7b242-db33-46fc-9080-c3d6a6fd55ec.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/372e7d6f-7fb9-4668-92f0-25bb9a346814.jpeg?im_w=720 ",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/4756e699-f474-4ca7-8b77-06b12715a6cb.jpeg?im_w=720 ",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/fca892a4-3481-4ad1-9f92-404feaa42e9f.jpeg?im_w=720 " ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/36d8007a-0de5-439d-9fec-1c2d7b53a147.jpeg?im_w=720",
        location:"london",
        pets:true,
    },

    {
        id:"2",
        homeMainPic: "https://a0.muscache.com/im/pictures/0b25f6b3-f215-4938-ac81-581eb3929047.jpg?im_w=720",
        name:"Balian Beach",
        price: 400,
        type:"tropical",
        stars: "4.84",
        carouselPic1: "https://a0.muscache.com/im/pictures/7cc3c855-f90e-4d0f-9b13-3b5c2a3c4bad.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/9833de62-35b7-41f2-8a24-0d9354150ea7.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/de73abc2-5dc9-4962-ba32-5d28211cdde0.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/92d22326-8207-4357-951b-35dab300db95.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/f52d2902-c301-400f-84c9-373efa448854.jpg?im_w=720",
        location:"london",
        pets:true,
    },

    {
        id:"3",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/bb35bfcf-f276-4e00-a0d1-73b319b2a9cd.jpeg?im_w=720",
        name:"Ubud Mansion",
        price: 200,
        type:"tropical",
        stars: "4.64",
        carouselPic1: "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/1854bf1b-dc40-49ed-9c2e-d378663a7a02.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/da951ef9-3fed-4c15-b4b8-2cd5b24357a9.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/ce7599e7-5560-4bed-9fc5-c0bc82d70fd0.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/5612048a-ab35-4ca5-81e8-646d2f7a2b3c.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/8983f2dc-6d79-48a6-8f8f-656fda0982a4.jpeg?im_w=720",
        location:"london",
        pets:true,
    },

    {
        id:"4",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/ab9a30d4-a6cf-4b3a-8416-cf7314ed5432.jpeg?im_w=720",
        name:"Selat Mansion",
        price: 2000,
        type:"tropical",
        stars: "4.94",
        carouselPic1: "https://a0.muscache.com/im/pictures/f2a6d022-23fc-4701-b703-806870cd9ed7.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/b0385f97-cc39-4f12-980a-05d561cc19a3.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/411c07b5-c03b-4bf7-a0fc-65ea439be452.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/40036a49-6fc1-45f4-9988-9f49c26c902a.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/e8429c29-d29b-4333-ae9f-4163265429fc.jpeg?im_w=720",
        location:"london",
        pets:false,
    },

    {
        id:"5",
        homeMainPic: "https://a0.muscache.com/im/pictures/4f70b681-a792-4530-8c52-f2a8d262942d.jpg?im_w=720",
        name:"Selat Mansion",
        price: 2000,
        type:"tropical",
        stars: "4.94",
        carouselPic1: "https://a0.muscache.com/im/pictures/e15ee353-0861-44ed-868a-56091755e513.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/45a3aa2b-ce00-4068-9ebe-9f83ca281fe4.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-43629767/original/ec85ccc0-281c-44fc-a061-bc1e87ea0081.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/f474dfbe-557a-4d07-8d6e-76aba506b5a6.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/0c37c239-fe53-4ae5-9e70-34d3988342da.jpg?im_w=720",
        location:"london",
        pets:false,
    },

    {
        id:"6",
        homeMainPic: "https://a0.muscache.com/im/pictures/prohost-api/Hosting-46761225/original/11058c0d-fac8-4035-8f16-8b3abe7441cd.jpeg?im_w=720",
        name:"Kekamatan Ubud",
        price: 5000,
        type:"tropical",
        stars: "4.54",
        carouselPic1: "https://a0.muscache.com/im/pictures/prohost-api/Hosting-46761225/original/08ca9cc1-6c85-4663-9faa-114e1c00956e.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/31a82697-b77d-4e79-aa4f-cfdb65f967ec.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-46761225/original/797d317f-a624-40eb-99de-2f3219176317.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-46761225/original/762acbae-692b-4054-b49e-0970f83feda3.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/5564847a-c678-4e39-8de1-2f591d017657.jpg?im_w=720",
        location:"london",
        pets:false,
    },

    {
        id:"7",
        homeMainPic: "https://a0.muscache.com/im/pictures/ab61d106-3c6e-4f4f-a9d6-3f16cfa3eaeb.jpg?im_w=720",
        name:"Banjar Kutukh Kaja",
        price: 500,
        type:"tropical",
        stars: "4.84",
        carouselPic1: "https://a0.muscache.com/im/pictures/ddfe37fc-ffd9-463e-a662-6239b251384b.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/1b697e43-ddb6-4df6-b753-d9be5ec4ceb5.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/a7b0e74c-01ed-4be2-a5af-7e9fcffe64a6.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/b34ec56f-3040-4f04-98a1-c37af9351b92.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/e120ceab-9202-41c2-ac07-58ea082eef8b.jpg?im_w=720",
        location:"london",
        pets:false,
        couple:true,

    },

    {
        id:"8",
        homeMainPic: "https://a0.muscache.com/im/pictures/4a5c629b-9c92-450e-8d8f-995875798838.jpg?im_w=720",
        name:"Tampakasirirng",
        price: 9000,
        type:"tropical",
        stars: "4.97",
        carouselPic1: "https://a0.muscache.com/im/pictures/08a9afde-e2f2-48aa-b8b0-a7e747318943.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/0295e1cd-09fe-448a-b837-7bf5ade3809c.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/b51f509a-9c94-4d1c-a31c-1a465e1670ac.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/6d3f81b5-affa-4c13-8681-4081d2568be6.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/42c0bbcb-29e5-4064-adad-6382393dce0f.jpg?im_w=720",
        location:"london",
        pets:false,
        couple:true,

    },

    {
        id:"9",
        homeMainPic: "https://a0.muscache.com/im/pictures/4ca0a7e5-9777-4ba6-9fce-8a0a94bbe555.jpg?im_w=720",
        name:"Uluwatu",
        price: 4500,
        type:"tropical",
        stars: "4.75",
        carouselPic1:  "https://a0.muscache.com/im/pictures/ca3de64a-addf-40dc-a368-c272ddd9b2bc.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/bb595700-650e-4db1-9ae7-9688b46628d1.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/a29a3aed-a774-44b8-93ea-98698d481a4e.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/9b72d952-fa69-4ab6-a95d-9fd88a06c879.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/208e78d4-9e16-4916-aff5-4392e8185607.jpg?im_w=720",
        location:"london",
        pets:false,
        couple:true,

    },

    {
        id:"10",
        homeMainPic: "https://pkslist.azureedge.net/media/images/1/f0d9eaca-d606-47bc-96b9-5096ef689e4b/800x600.jpg",
        name:"Kecamatana",
        price: 8000,
        type:"tropical",
        stars: "4.45",
        carouselPic1:  "https://pkslist.azureedge.net/media/images/1/31214da3-6911-4f36-bf03-97e37d5e7164/800x600.jpg",
        carouselPic2 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/79cca65b-4fe8-444e-94c8-48987b61164a.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/9db32a8a-8b56-4157-92a4-8a39bb3d944f.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/14309683-a315-4677-a92b-7824d7027b9e.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/837c0387-847d-49f5-bae9-91572284b822.jpeg?im_w=720",
        location:"london",
        pets:false,

    },

    {
        id:"11",
        homeMainPic: "https://a0.muscache.com/im/pictures/6d90bd2d-1bae-47cc-b831-b7561d766048.jpg?im_w=720",
        name:"Seirit",
        price: 5000,
        type:"tropical",
        stars: "4.72",
        carouselPic1:  "https://a0.muscache.com/im/pictures/26bfb0b8-27a2-45d2-8021-9ffc2d28d6c1.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/b30f5628-79ff-4e48-b600-8c515f72dde5.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/f2026c2f-028b-4a4f-895d-2fea973d9609.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/582c5bd6-65b1-41e3-83d5-97d75d45aab7.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/588a6c44-4a6a-4812-bf5b-fa8925f17271.jpg?im_w=720",
        location:"london",
        pets:false,
    },

    {
        id:"12",
        homeMainPic: "https://a0.muscache.com/im/pictures/81aaba9d-ec2b-4f83-ab67-1f4c6dbccc17.jpg?im_w=720",
        name:"Kambalo",
        price: 6500,
        type:"tropical",
        stars: "4.98",
        carouselPic1:  "https://a0.muscache.com/im/pictures/34bf6c0e-655e-4ab7-b569-d7e234a06c17.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/757e92e9-9a2d-4972-80eb-57665aeb9c55.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/d7dfc560-6dd2-4c6c-86ba-c238997848c2.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/c08997f4-625c-4d31-a8cf-3a579456774e.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/dad47893-747f-406c-8697-7efa1f263d47.jpg?im_w=720",
        location:"russia",
        pets:true,
    },

    {
        id:"13",
        homeMainPic: "https://a0.muscache.com/im/pictures/881f0d54-6449-402a-8ffe-499664d302bf.jpg?im_w=720",
        name:"Mengwi",
        price: 1500,
        type:"tropical",
        stars: "4.58",
        carouselPic1:  "https://a0.muscache.com/im/pictures/fa9aa1b5-3e63-4e1c-863d-5e63702794da.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/d84bccce-0567-4b47-a165-f7a22219aab4.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/75333e4f-4519-4897-9a8a-c0afbba7ce87.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/4ab0201a-00e9-44b6-8888-1ed553e36dc1.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/43e423f2-5b07-4f4b-a9e5-7fa8633154fc.jpg?im_w=720",
        location:"russia",
        pets:true,
    },

    {
        id:"14",
        homeMainPic: "https://a0.muscache.com/im/pictures/monet/Luxury-20470768/original/cc213ade-c939-4e2f-b0af-0149bda85030?im_w=720",
        name:"Samaui",
        price: 1500,
        type:"tropical",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/6d3bd191-b013-4cf9-b297-5f3c253acadf.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/84242eab-0733-43a0-bea6-8934b62df1cf.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/1a62d125-294d-4ea8-ac01-8fdcd65f85da.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/1900a5c5-4f54-4bff-af26-1c102e4bcd45.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/83eda27f-50be-4356-8d74-0c40ef73226a.jpg?im_w=720",
        location:"russia",
        pets:true,
    },

    
    {
        id:"15",
        homeMainPic: "https://a0.muscache.com/im/pictures/06d92669-7b0e-4e09-a001-00b5f956d619.jpg?im_w=720",
        name:"Kubata",
        price: 8500,
        type:"tropical",
        stars: "4.62",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-17700584/original/2f78f22e-1fe9-4ec6-b5fc-31551dc33b2d.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/84242eab-0733-43a0-bea6-8934b62df1cf.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/1a62d125-294d-4ea8-ac01-8fdcd65f85da.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/1900a5c5-4f54-4bff-af26-1c102e4bcd45.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/83eda27f-50be-4356-8d74-0c40ef73226a.jpg?im_w=720",
        location:"russia",
        pets:true,
    },


    // tab 2 i.e nationalpark starts

    
    {
        id:"16",
        homeMainPic: "https://a0.muscache.com/im/pictures/2d8ea58a-bb1c-4145-9f48-94fcbaafc8a6.jpg?im_w=720",
        name:"Badungr",
        price: 6650,
        type:"nationalpark",
        stars: "4.25",
        carouselPic1:  "https://a0.muscache.com/im/pictures/08b70c1e-c97d-480b-8798-dcc6e49b07be.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/8357e216-0b4f-43dd-bd12-002ba8f5e8ea.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/c90703e9-ec45-4f56-ab90-cff407998cbe.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/b14eb182-33e3-4294-915e-c4b07fc93f7f.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/7eeca0cf-90e1-468a-beba-a64251b2e109.jpg?im_w=720",
        location:"russia",
        pets:false,
    },

    {
        id:"17",
        homeMainPic: "https://a0.muscache.com/im/pictures/e44d6ea0-d174-4024-9fac-c254c55b1221.jpg?im_w=720",
        name:"SagoFil",
        price: 4500,
        type:"nationalpark",
        stars: "4.85",
        carouselPic1:  "https://a0.muscache.com/im/pictures/4af87cc3-3d31-41c3-9b5e-f436535bf4e7.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/c1771c68-5f05-4a59-9449-76ea725b6ec0.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/617bbc92-658b-4f10-9565-e14373ad2d40.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/118f979e-d9c7-4620-be03-18c81d3883a3.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/fb38e48e-b2da-4694-a553-2ba51bcf8f69.jpg?im_w=720",
        location:"russia",
        pets:false,
        couple:true,

    },

    
    {
        id:"18",
        homeMainPic: "https://a0.muscache.com/im/pictures/a98abbe7-615f-45a9-a614-37910e7e909e.jpg?im_w=720",
        name:"Cancona",
        price: 4800,
        type:"nationalpark",
        stars: "4.87",
        carouselPic1:  "https://a0.muscache.com/im/pictures/fe9e0540-4750-41e1-9135-729cb1c61340.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/7e941d32-dd35-40e3-b8c9-693e04c39682.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/ad25f1ec-ca77-48fa-aa91-82b133e6621d.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/2383e199-b0d1-45b9-b003-359172534abc.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/5b88976e-873b-4126-9bc2-7197434d40cb.jpg?im_w=720",
        location:"russia",
        pets:false,
        couple:true,

    },

    
    
    {
        id:"19",
        homeMainPic: "https://a0.muscache.com/im/pictures/957489e8-c915-4208-a99d-c75334d5d58e.jpg?im_w=720",
        name:"Loutulim",
        price: 8800,
        type:"nationalpark",
        stars: "4.91",
        carouselPic1:  "https://a0.muscache.com/im/pictures/6c4f0013-6650-4184-9b6d-083cc254d45f.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/72182496-2965-45ba-9858-1bf06a03b8d1.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/d1c2e3bd-aebe-4fcf-b91f-f0bc557666f1.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/891736e3-a1b3-461c-895c-65f5ebc22ada.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/bd68eb62-b199-4f18-a9e4-5f7ca590d168.jpg?im_w=720",
        location:"russia",
        pets:false,
        couple:true,

    },

    {
        id:"20",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/6316e9f3-9f94-43b0-8d84-30e0a9516663.jpeg?im_w=720",
        name:"Panji",
        price: 6752,
        type:"nationalpark",
        stars: "4.85",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/f6a7ecab-e303-49cb-8e3d-46c5bed00001.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/dc962781-52af-4394-b5d1-305303eda44f.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/47e80e89-ed7d-44c8-aa58-e474e89c9efa.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/7ca45d8b-ceb8-49c0-9f0c-a9953a8801e6.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/9aae2290-471b-4e5c-ab2a-159c5c79ca80.jpeg?im_w=720",
        location:"europe",
        pets:true,
    },

    {
        id:"21",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/ab9a30d4-a6cf-4b3a-8416-cf7314ed5432.jpeg?im_w=720",
        name:"Colava",
        price: 7800,
        type:"nationalpark",
        stars: "4.8",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/ca837f4e-fc63-4de8-8abd-d867f5045196.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/777e902a-8d7d-405a-80ca-97f89749b91e.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/04398ee5-0e48-462a-86a0-a3801bad2172.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/ca837f4e-fc63-4de8-8abd-d867f5045196.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/49cddd92-0663-4ec8-8272-43f207fcfd4f.jpeg?im_w=720",
        location:"europe",
        pets:true,
    },

    {
        id:"22",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-45796358/original/aa1e124c-81b9-4d7b-9707-51fe7ce9658d.jpeg?im_w=720",
        name:"Varca",
        price: 8475,
        type:"nationalpark",
        stars: "4.93",
        carouselPic1:  "https://a0.muscache.com/im/pictures/27206bd1-e7c8-4e6c-a821-df71e5cc884a.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/9334fc54-f39c-4142-85ad-d9bd9d171e2d.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-45796358/original/906b57d5-25a6-4dcb-884b-2d9dca6de7bc.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-45796358/original/aa387941-f79c-4737-8b7f-db42ae8f8df6.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-45796358/original/4ed4eb30-1917-4f20-9f1c-95619ccf6682.jpeg?im_w=720",
        location:"europe",
        pets:true,
    },

    {
        id:"23",
        homeMainPic: "https://a0.muscache.com/im/pictures/c25c9546-5a2e-4092-bbae-d294836014e2.jpg?im_w=720",
        name:"Mandel",
        price: 5975,
        type:"nationalpark",
        stars: "4.93",
        carouselPic1:  "https://a0.muscache.com/im/pictures/5fd5a247-7ab4-4e71-abbb-fd1b331770d4.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/770c5620-568d-44cc-84ee-5d99c052dd23.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/ca82c468-aeec-4550-bc44-ba69f6883f18.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/7db2eaa3-60ed-4332-9633-7650e208d7a1.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/fdcb4dd6-d48d-4e1b-9f0a-dc01cadeef91.jpg?im_w=720",
        location:"europe",
        pets:true,
    },

    {
        id:"24",
        homeMainPic: "https://a0.muscache.com/im/pictures/a93e9798-69cd-48d3-a7a0-1753e31bb60b.jpg?im_w=720",
        name:"Babek",
        price: 4975,
        type:"nationalpark",
        stars: "4.43",
        carouselPic1:  "https://a0.muscache.com/im/pictures/9851d648-50cd-4a01-84a5-c55a5b6f6c73.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-39564407/original/12622023-1277-432c-b923-b6ea574ca83d.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-39564407/original/db725b5d-05b2-4363-97e3-96dde878d379.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-39564407/original/66f7feff-3c16-4439-9ba4-832cfdcbca72.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/050244f0-23e1-47d8-8c30-1c1c4be9e030.jpg?im_w=720",
        location:"europe",
        pets:false,
    },

    
    {
        id:"25",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/75594cf3-d551-485c-9a2d-2f735b9a75f4.jpeg?im_w=720",
        name:"Daramob",
        price: 7825,
        type:"nationalpark",
        stars: "4.37",
        carouselPic1:  "https://a0.muscache.com/im/pictures/01376579-dae6-4f03-a9f6-b7c7b91ca681.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/75b18059-523c-4c8f-b67f-704ec9b342be.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/a99e41e5-1aed-49e3-b2ce-2d0e00e9d76f.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/779675f8-2c82-43e3-858b-ab81fe15f737.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/cd53984e-0366-497c-a9da-9363c95bdcd2.jpg?im_w=720",
        location:"europe",
        pets:false,
    },

    {
        id:"26",
        homeMainPic: "https://a0.muscache.com/im/pictures/73b21cbb-5c7f-47ce-850b-bdb85e5d2133.jpg?im_w=720",
        name:"Colva",
        price: 4664,
        type:"nationalpark",
        stars: "4.57",
        carouselPic1:  "https://a0.muscache.com/im/pictures/38ee6fc8-bdd8-43e1-9b34-e3ef4edd68d4.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/8b40260f-c4f1-46e4-b93a-45bb6cd1840b.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/9fb6a440-290f-4c0c-becf-0cea63358278.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/779675f8-2c82-43e3-858b-ab81fe15f737.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/cd53984e-0366-497c-a9da-9363c95bdcd2.jpg?im_w=720",
        location:"europe",
        pets:false,
    },

    {
        id:"27",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/537432f3-ff14-403a-9088-2fa4521b59c8.jpeg?im_w=720",
        name:"Nigdmah",
        price: 6864,
        type:"nationalpark",
        stars: "4.87",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/e348b1cc-1bed-4c0f-88f2-21c421d452f4.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/2a637d8d-40e4-4b79-abcb-82f4a3bc9a78.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/52bb6a56-6001-4812-a4c3-753fe697173d.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/a08e1a30-a20d-4fb1-a985-c9d8ab65b579.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/0562e372-9762-45af-97c6-eb658b38e412.jpeg?im_w=720",
        location:"europe",
        pets:false,
    },

    
    {
        id:"28",
        homeMainPic: "https://a0.muscache.com/im/pictures/deaf6622-8244-4059-a791-ae9256a58f1a.jpg?im_w=720",
        name:"Orlim",
        price: 4935,
        type:"nationalpark",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/5de25524-6815-4f97-81b0-6990531285ab.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-53484390/original/41bd01b2-b376-4a87-82bd-534471399d7a.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/3e307ee0-6750-474c-b07f-151a50140a79.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/a3639494-a256-4804-a67b-32ac9c2f8551.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/69d1e422-9e7c-4b3f-8772-7e50df9e16c8.jpg?im_w=720",
        location:"europe",
        pets:false,
        couple:true,

    },
    
    {
        id:"29",
        homeMainPic: "https://pkslist.azureedge.net/media/images/1/3273ffcb-d3fe-41c2-9b12-99e675500551/800x600.jpg",
        name:"Utora",
        price: 8965,
        type:"nationalpark",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/b13f14f7-6fa2-4f9e-9b77-dfca3c673634.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/56499391-b902-4b07-a6c5-b7479debb3d2.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/10b01df3-5487-417b-90b9-d102d33b61d5.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/402a072f-91b9-4467-8e69-c7c5a3519646.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/69d1e422-9e7c-4b3f-8772-7e50df9e16c8.jpg?im_w=720",
        location:"europe",
        pets:false,
        couple:true,

    },

    {
        id:"30",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-52743271/original/58716c75-1031-401a-990f-ad644e054259.jpeg?im_w=720",
        name:"Habiora",
        price: 8965,
        type:"nationalpark",
        stars: "4.85",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-52743271/original/3f305981-7cdf-464d-9e3d-494fed3528d9.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-52743271/original/4baec95d-148e-4635-8eba-852f91b9f19d.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-52743271/original/4bcc3d88-dbb7-4ca5-8940-7b106678ac85.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/68050026-d4a0-4fb8-b89d-a5d80a881940.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/a82a6ebf-9d6b-4d8d-9a4a-2dd9a72a18df.jpg?im_w=720",
        location:"europe",
        pets:false,
        couple:true,

    },
    // tab3 i.e amazing pools

    {
        id:"31",
        homeMainPic: "https://a0.muscache.com/im/pictures/321a1e3a-2827-46f8-8966-9910c9678ca8.jpg?im_w=720",
        name:"Colava",
        price: 5725,
        type:"amazingpools",
        stars: "4.96",
        carouselPic1:  "https://a0.muscache.com/im/pictures/5e51dcbb-6572-435b-aae0-a8a484748f21.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/5191dfd3-c209-4c93-b395-f562b9edc198.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/712e96eb-6517-4704-b443-d4f93a45a85a.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/9680085e-def2-4c16-90cb-4b10e519454a.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/ff3724e2-222b-4d01-b40d-8a95726ce01c.jpg?im_w=720",
        location:"newyork",
        pets:true,
    },

    {
        id:"32",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/3ae97076-6969-49da-8a20-f461b4b86903.jpeg?im_w=720",
        name:"Candolim",
        price: 7582,
        type:"amazingpools",
        stars: "4.94",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/ef2d3504-93df-49ed-8477-5b9a2b080037.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/ac993a19-97c9-4b9b-b1a1-1dcd30215049.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/65b2bee2-6ced-45e3-9f76-6fb9e1022fc2.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/b5a61252-ec39-46b3-80d4-87efa5e15e16.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/a0805e2a-339e-4a9d-9086-3e73163ff36c.jpeg?im_w=720",
        location:"newyork",
        pets:true,
    },

    
    {
        id:"33",
        homeMainPic: "https://a0.muscache.com/im/pictures/981afb1a-07d1-42c8-9c65-1ca842f6de6a.jpg?im_w=720",
        name:"Matata",
        price: 8452,
        type:"amazingpools",
        stars: "4.84",
        carouselPic1:  "https://a0.muscache.com/im/pictures/ad8bb103-8eb9-4403-9381-501a9e8e3053.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/a51605ae-48b0-4782-982a-dbb77a057b58.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/527ca877-1e17-411d-af8f-69d3651dafd1.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/b65120e7-ba59-4fcd-8df0-42849e072a39.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/a1339bdd-ea92-4127-893d-721e60d1da9c.jpg?im_w=720",
        location:"newyork",
        pets:true,
    },

    {
        id:"34",
        homeMainPic: "https://a0.muscache.com/im/pictures/0cc71977-6c16-4f16-9462-205b152b44f6.jpg?im_w=720",
        name:"Colva",
        price: 3500,
        type:"amazingpools",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/ec6a643e-3f9c-4e2d-98a0-09b1f5f26f4b.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/7312e052-de8e-4a5b-872f-f1bce5e0b670.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/16d3733d-d472-4daf-a873-8ee5b74ab3c5.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/348e0dd5-7f90-4b88-8219-ae60eb0717ed.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/5fee595d-910c-4cfc-9174-727560b40263.jpg?im_w=720",
        location:"newyork",
        pets:true,
    },

    {
        id:"35",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/8aec4c00-ae4b-4432-82e6-adcd7f462a74.jpeg?im_w=720",
        name:"Benaulia",
        price: 8750,
        type:"amazingpools",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/d7e1f632-4882-4bee-aa94-c19fc9440a9f.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/e9d024a6-2c90-4786-8d2a-303df05f30a4.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/5e78c5b6-38a9-4692-b3dd-41b42409182b.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/7964798e-a499-4eb7-9249-45b43232ef88.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/b48927ce-4538-464f-93a8-fa557d657069.jpeg?im_w=720",
        location:"newyork",
        pets:false,
    },

    {
        id:"36",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/8fe3b3d4-b0bd-4aff-9836-0805244590e4.jpeg?im_w=720",
        name:"Calangute",
        price: 6300,
        type:"amazingpools",
        stars: "3.8",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/20d43aeb-b30c-4d9c-9c2c-d62ade05d117.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/f9c505c2-865b-4e2a-96f0-003ff760f6cd.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/2b40593e-96e9-49d7-bb75-f8ed746c1b5e.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/f9ef5ea3-4f8d-4fd8-93f6-83a439c2e9e4.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/9847b513-fbd4-4548-a667-ac3daaaded66.jpeg?im_w=720",
        location:"newyork",
        pets:false,
    },

    
    {
        id:"37",
        homeMainPic: "https://a0.muscache.com/im/pictures/3d8b4db2-0bc3-4bf7-91d7-0d34dd2bb903.jpg?im_w=720",
        name:"Norgod",
        price: 8050,
        type:"amazingpools",
        stars: "4.2",
        carouselPic1:  "https://a0.muscache.com/im/pictures/4c3ed092-cd1a-4661-ac41-f4bae8527044.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/96f83ec9-7b0f-4345-814c-f7464f3ddd04.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/5e4fb4a1-30c7-485f-8ae2-4c7fa8f902d7.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/43dce28d-5028-4fd6-b01e-7c84f80661d0.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/9847b513-fbd4-4548-a667-ac3daaaded66.jpeg?im_w=720",
        location:"newyork",
        pets:false,
    },

    {
        id:"38",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/0baf5958-7293-48df-9c25-3c5d23c1f297.jpeg?im_w=720",
        name:"NeeurlPea",
        price: 4580,
        type:"amazingpools",
        stars: "4.87",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/d953812b-fd01-4732-9dd4-84240eacbdac.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/6ba6a13a-7de8-4d74-8593-aaf5f736a61c.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/becb9817-ee32-42eb-824d-f5ac4ee3e31b.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/83683b42-999a-4ca3-9db3-c56f8da0ed55.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/7b5cca14-b624-4314-a7cc-f59d92839317.jpeg?im_w=720",
        location:"newyork",
        pets:false,
        couple:true,

    },

    {
        id:"39",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/3d515645-215b-40bc-8edc-d086fdbd182d.jpeg?im_w=720",
        name:"Loutotlim",
        price: 7850,
        type:"amazingpools",
        stars: "4.47",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/59f59a30-e692-47fa-9dc0-7bf8e100c18b.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/709a250b-3e07-48ab-ac8f-4609739997e3.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/29eba09c-addd-4387-927a-93b53734f046.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/d4bac09d-9d47-414f-82ab-728f7cdc3a9b.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/51831d57-edd4-4c50-b804-6468fb766bb3.jpeg?im_w=720",
        location:"newyork",
        pets:false,
        couple:true,

    },

    {
        id:"40",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/227ad5c1-8855-4370-9f9a-97034281c3e2.jpeg?im_w=720",
        name:"Betatime",
        price: 7850,
        type:"amazingpools",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/7090cc2a-27e8-45d7-a825-0b1854145e25.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/fe4bd8db-8d59-40ff-8629-9314a3359a3b.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/64598820-934a-4f1a-b19f-b6bcbfb17810.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/32b426ec-405e-4c21-94f7-f55d32287cce.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/bf8a0b70-fa2b-4ebd-8502-43a3658bae84.jpeg?im_w=720",
        location:"newyork",
        pets:false,
        couple:true,

    },

    {
        id:"41",
        homeMainPic: "https://a0.muscache.com/im/pictures/5b4d3ab2-bae2-4c82-b05a-83467a5b076e.jpg?im_w=720",
        name:"Noshdan",
        price: 4782,
        type:"amazingpools",
        stars: "4.56",
        carouselPic1:  "https://a0.muscache.com/im/pictures/33c63039-6e52-4bf9-873a-ec39061e2c88.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/a5023daa-037e-4a82-b746-51a882781c32.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/8fe1fef2-d2e6-4c44-9729-a763e38bb666.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/fa15f4e2-8ee2-4b51-8057-78009947a0da.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/c4731a81-c2b6-4646-85e2-12b8a001c79b.jpg?im_w=720",
        location:"ukraine",
        pets:true,
    },

    {
        id:"42",
        homeMainPic: "https://a0.muscache.com/im/pictures/1e36056e-2f67-4ad9-aa39-0547b2cfaeff.jpg?im_w=720",
        name:"Sangchi",
        price: 5800,
        type:"amazingpools",
        stars: "4.76",
        carouselPic1:  "https://a0.muscache.com/im/pictures/4af87cc3-3d31-41c3-9b5e-f436535bf4e7.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/c1771c68-5f05-4a59-9449-76ea725b6ec0.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/617bbc92-658b-4f10-9565-e14373ad2d40.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/118f979e-d9c7-4620-be03-18c81d3883a3.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/fb38e48e-b2da-4694-a553-2ba51bcf8f69.jpg?im_w=720",
        location:"ukraine",
        pets:true,
    },

    {
        id:"43",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-671456595560845798/original/880f54ce-51c7-44ed-903f-d9b11f674707.jpeg?im_w=720",
        name:"Neurl",
        price: 7490,
        type:"amazingpools",
        stars: "4.26",
        carouselPic1:  "https://a0.muscache.com/im/pictures/d8da6b20-941a-4214-af21-737cf29b308a.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/c2247faf-d96b-4d17-b328-ab9a6356aa75.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-40214539/original/73b81efc-e658-4eba-a488-9b3b658c1b4e.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/ff25b7e5-0fb7-4f45-9fc3-63bf5ac251af.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/0f2bfb30-6951-4e93-b2e7-0015a80d91b4.jpg?im_w=720",
        location:"ukraine",
        pets:true,
    },

    
    {
        id:"44",
        homeMainPic: "https://a0.muscache.com/im/pictures/7e44319c-704f-4345-8bce-4601c893ed16.jpg?im_w=720",
        name:"Nilofer",
        price: 5060,
        type:"amazingpools",
        stars: "4.86",
        carouselPic1:  "https://a0.muscache.com/im/pictures/09667e04-d6d4-455e-afe2-a7ba2427a683.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/ac63eb86-504c-4438-8f25-26c27778734d.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/03967072-9fcb-4072-a36d-cb9f677b0ff6.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/86ba0630-3d48-4e71-82f0-c5551f271fa9.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/343f76e7-434e-4090-82f3-da5f6a229a29.jpg?im_w=720",
        location:"ukraine",
        pets:false,
    },

    {
        id:"45",
        homeMainPic: "https://a0.muscache.com/im/pictures/a40a31ef-1a1a-4044-94bf-2d9a1c71b2b3.jpg?im_w=720",
        name:"Aura",
        price: 8200,
        type:"amazingpools",
        stars: "4.86",
        carouselPic1:  "https://a0.muscache.com/im/pictures/14c70a65-fd0f-465b-b698-54787d7ea262.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-28292714/original/6c0c70d4-5e3b-41df-80f6-9ab0a8b3be4a.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-28292714/original/d7b8e599-14a7-404d-a8c7-fee82a34270b.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-28292714/original/e778a24f-d500-413c-b731-e15b9244ea12.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-28292714/original/5a737bcb-32db-4d8f-aedb-e707fae42a41.jpeg?im_w=720",
        location:"ukraine",
        pets:false,
    },

    // tab 4 beaches

    {
        id:"46",
        homeMainPic: "https://a0.muscache.com/im/pictures/c7fdf7b1-4624-42e0-ab9c-5c002bc04c02.jpg?im_w=720",
        name:"Caluengete",
        price: 8200,
        type:"beaches",
        stars: "4.88",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-46228387/original/e3304144-a0bd-4c1c-a1f0-37b18261b35b.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/ed085b52-a71b-417a-81bb-bebaf5ba83ca.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-46228387/original/f72773a3-aad2-44bd-bcee-d381b906f6f0.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/82e8b194-8d7d-45cd-939b-4395300e1b2c.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/024407cb-22e1-43b1-a6e6-5673c553d82a.jpg?im_w=720",
        location:"ukraine",
        pets:false,
    },

    {
        id:"47",
        homeMainPic: "https://a0.muscache.com/im/pictures/58ea01f6-762a-4730-9106-92b463d2b255.jpg?im_w=720",
        name:"Aqua",
        price: 7850,
        type:"beaches",
        stars: "4.58",
        carouselPic1:  "https://a0.muscache.com/im/pictures/9932a298-6b1c-4c96-b2c8-df85f319c44a.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/30c89fc8-dc65-488c-bb12-3bbc3bab2070.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/f8c88457-1b72-4b4f-a811-8f6217dc20b6.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/00e695c6-001c-4876-a786-6278289fea5e.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/8a682100-6af3-425a-a5a0-831fae9e196a.jpg?im_w=720",
        location:"ukraine",
        pets:false,
    },

    {
        id:"48",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/ce12769c-4d54-4ac3-8db0-f7530aa88144.jpeg?im_w=720",
        name:"Vagator",
        price: 1500,
        type:"beaches",
        stars: "4.88",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/d7768904-e0e1-4867-9022-7e80c192e74d.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/a11a084b-84c0-4850-ad2b-8c2002318171.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/6b88d7c9-f873-42d3-b4b6-2fea3a176a18.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/b1280db1-aae5-4586-8389-5eb3dfb02b83.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/26386ced-5f26-4cc8-a0d5-cead091c1422.jpg?im_w=720",
        location:"ukraine",
        pets:false,
        couple:true,

    },

    {
        id:"49",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/347ab2a7-537a-4c1c-9d22-ae7af0319c17.jpeg?im_w=720",
        name:"Cancona",
        price: 2500,
        type:"beaches",
        stars: "4.98",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/810a217b-b081-48a0-974d-db0ee77e95c5.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/d46de5b9-5207-4ea1-8cbf-aa1169dba64c.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/47a03d51-f249-46f4-92f5-3bc9a970d2e0.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/f6ba5dfe-139d-4563-9c29-a6515467179f.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/347ab2a7-537a-4c1c-9d22-ae7af0319c17.jpeg?im_w=720",
        location:"ukraine",
        pets:false,
        couple:true,

    },

    {
        id:"50",
        homeMainPic: "https://a0.muscache.com/im/pictures/5314255c-ea99-4b29-9a5c-1ae56f3d9f37.jpg?im_w=720",
        name:"Panjali",
        price: 8850,
        type:"beaches",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/d42c3708-0767-45c2-afec-48f58ae5f37b.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/6594e7fa-99ad-4641-b9ec-29df3665be4f.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/b51588c7-84e5-4b7a-94db-b0220ebb325d.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/44cdb32e-02fc-4970-8a30-5d6ddaf9a623.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/4062779b-8434-4e07-84f7-32e5d4c37cdb.jpg?im_w=720",
        location:"ukraine",
        pets:false,
        couple:true,

    },

    
    {
        id:"51",
        homeMainPic: "https://a0.muscache.com/im/pictures/0df3b66e-b1e2-4bca-9c2b-300c28926569.jpg?im_w=720",
        name:"Coladre",
        price: 7895,
        type:"beaches",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/23052913-099c-4a3a-8f69-dddc2734782c.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/ff4f00ab-b2f2-403b-acd9-65e9dff0dced.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/169b4678-f038-427d-b3b9-06348af8f20c.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/7e121fdf-100d-4ab5-b323-7a9917db465c.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-45731930/original/bffdd0b5-271e-4836-8607-57efad2e70bb.jpeg?im_w=720",
        location:"india",
        pets:true,
    },

    {
        id:"52",
        homeMainPic: "https://a0.muscache.com/im/pictures/prohost-api/Hosting-45731930/original/bffdd0b5-271e-4836-8607-57efad2e70bb.jpeg?im_w=720",
        name:"Mandela",
        price: 1889,
        type:"beaches",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/e29175b2-3cd2-4f9a-bb9b-7630317ba2bc.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/266291b1-f23d-4c90-8e71-5dac0acba81d.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/1efa86a3-adbe-47f4-ab26-fe4484568c4a.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/2e52d3bc-3b96-4b7f-9b6e-2f7d14d9e141.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/19bb367a-6b23-4ff4-be08-7fe5fcac1859.jpg?im_w=720",
        location:"india",
        pets:true,
    },

    {
        id:"53",
        homeMainPic: "https://a0.muscache.com/im/pictures/79ee6640-f7c6-4775-b18f-eea593565e9d.jpg?im_w=720",
        name:"Orya",
        price: 5680,
        type:"beaches",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/c92ed58a-2958-4f1b-b6bc-05e7cac92b04.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/9bf63f70-bbfa-47bc-8390-d5aaff6ec6e6.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/3d1bd274-b968-4546-a405-3e59e19a366c.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/0e28b47f-0ad1-4782-ad1a-1a86c21dfedd.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/9490dd4c-f9b6-4d42-9ca9-eaeccd019b99.jpg?im_w=720",
        location:"india",
        pets:true,
    },

    {
        id:"54",
        homeMainPic: "https://a0.muscache.com/im/pictures/0f8822af-f738-431b-a30f-ccc8ff7f31ee.jpg?im_w=720",
        name:"Equpd",
        price: 7800,
        type:"beaches",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/0750bacd-1294-4707-8ef5-25f21e5f3759.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/e2636128-eb3c-4a6a-a2ab-49aa683aabc9.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/44996549-d82e-40ab-a79e-cfe8face9a27.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/79729789-c287-4677-98b3-41eb38784ba5.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/fc9e58d7-4660-4e36-a647-b30723534424.jpg?im_w=720",
        location:"india",
        pets:false,
    },

    {
        id:"55",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/4ab77d63-7116-41c8-957b-921209a1c0b9.jpeg?im_w=720",
        name:"Nilofouer",
        price: 9000,
        type:"beaches",
        stars: "4.80",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/f532f561-f0f6-4454-a0d9-230be7a66462.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/fb41ad46-9aeb-47cd-b814-ad53847e5977.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/8681edbb-ad74-4cc6-abd9-1db639f7e599.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/1bf7e8b4-cf5c-4568-9efc-edf83ee5b820.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/29365245-0953-4840-b9d3-09498da5b7ab.jpeg?im_w=720",
        location:"india",
        pets:false,
    },

    
    {
        id:"56",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/0e7d0e69-2edf-427b-90ae-b8245efba32c.jpeg?im_w=720",
        name:"Ora",
        price: 1450,
        type:"beaches",
        stars: "4.88",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/72c66a59-a92f-4579-a1c1-40bf679ce091.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/a218e8c6-7e82-493f-9886-aac39973f73a.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/8b05417a-3a6c-41ac-abcd-ade3bda1ff64.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/4d4cc31e-fbdd-46ac-9ac1-9f2e25310d95.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/a08e9dab-dd58-4ceb-86c7-ca33d961d8e9.jpeg?im_w=720",
        location:"india",
        pets:false,
    },

    {
        id:"57",
        homeMainPic: "https://a0.muscache.com/im/pictures/29a4d8ad-4ea1-4f6c-bd78-920bd3351e8a.jpg?im_w=720",
        name:"Quazi",
        price: 7456,
        type:"beaches",
        stars: "4.48",
        carouselPic1:  "https://a0.muscache.com/im/pictures/276901a4-9087-44d3-94c0-d2065d2a2f8d.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/ba1071e9-a2dd-4f0d-9316-33b877dcc897.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/9a1dbb53-62f1-4d7d-98df-2ee8e56881ba.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/338e3a00-f6e1-4c15-b47d-c818bce7785b.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/14e0cf79-c731-46d7-99e9-443303e0914f.jpg?im_w=720",
        location:"india",
        pets:false,
    },


    // tab 5 tiny homes
   
    {
        id:"58",
        homeMainPic: "https://a0.muscache.com/im/pictures/ac088d58-51ae-49a8-b126-156f87a1c4a6.jpg?im_w=720",
        name:"Tejuka",
        price: 4456,
        type:"tinyhomes",
        stars: "4.85",
        carouselPic1:  "https://a0.muscache.com/im/pictures/de11ba00-b8e7-4bef-bf6f-334eba32a477.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/9303a444-88fa-4feb-b135-2a333c5064cf.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/f3c4cabb-f56c-42c4-b9ef-7591d285b000.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/a053bd67-c321-4067-a69a-5fafa19df4d6.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/d3e935d8-c4b0-4678-bc5e-bc4dd1a3f74a.jpg?im_w=720",
        location:"india",
        pets:false,
        couple:true,

    },

    {
        id:"59",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-47181423/original/39c9d4e7-78d0-4807-9f0d-3029d987d02a.jpeg?im_w=720",
        name:"Pemenang",
        price: 4582,
        type:"tinyhomes",
        stars: "4.65",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-47181423/original/1f17c370-5c69-4a23-bdd4-b5adfaf6b33d.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/62339011-b61a-4ac4-a589-4fd8032c6c62.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-47181423/original/d333376b-b826-4173-810c-4c83881db29e.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-47181423/original/7690ee1e-55d5-4a31-8e7c-2c6926cbe43b.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/931043e6-10cb-4146-9569-2c814753ce2a.jpg?im_w=720",
        location:"india",
        pets:false,
        couple:true,

    },

    
    {
        id:"60",
        homeMainPic: "https://a0.muscache.com/im/pictures/ff8035de-1053-44fd-ad94-4b529120c4e4.jpg?im_w=720",
        name:"Tissulman",
        price: 7895,
        type:"tinyhomes",
        stars: "4.72",
        carouselPic1:  "https://a0.muscache.com/im/pictures/2cfebbdd-02dc-41fd-ac78-fafe4b7ac51e.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/71364ae7-1961-4691-8a10-c3a7ee00a2a6.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/85fe4995-4ddf-4275-8251-f5f2c16fb3d2.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/7d3ec7d4-26ce-4b26-ae08-1a8e8ce58231.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-47181423/original/bd57640b-516c-45fc-b21f-005caa0aba7e.jpeg?im_w=720",
        location:"india",
        pets:false,
        couple:true,

    },

      
    {
        id:"61",
        homeMainPic: "https://a0.muscache.com/im/pictures/05722dfc-522c-4362-9b3e-fcab749c7af6.jpg?im_w=720",
        name:"Varkala",
        price: 4580,
        type:"tinyhomes",
        stars: "4.43",
        carouselPic1:  "https://a0.muscache.com/im/pictures/d4edf966-9428-4344-be44-73bd1cb43e3b.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/660630cb-fec0-4ed5-8ecd-8370d9594760.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/6ea12e47-88e8-437c-8494-5306ea5d564a.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-47181423/original/aead7b49-d977-4ce3-a24e-de574bc3ad71.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/7b9788f8-af60-494e-8505-f95553045a88.jpg?im_w=720",
        location:"france",
        pets:true,
    },

    {
        id:"62",
        homeMainPic: "https://a0.muscache.com/im/pictures/b042a337-852f-4586-ac43-08ee8d61f4ab.jpg?im_w=720",
        name:"Meshju",
        price: 3698,
        type:"tinyhomes",
        stars: "4.77",
        carouselPic1:  "https://a0.muscache.com/im/pictures/25717ad9-1a05-4e56-8f94-d873fdf8f5e4.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/b13e8382-d762-4c31-a2f1-9c239afba346.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/9691f95b-f850-499b-a535-bc3847a32e51.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/ecfbc009-69eb-454f-8def-83b760d2ac42.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/577a2ba8-748f-42e1-bd65-fa8ed6cfbdc1.jpg?im_w=720",
        location:"france",
        pets:true,
    },

    {
        id:"63",
        homeMainPic: "https://a0.muscache.com/im/pictures/8ddc1468-d6e0-4f37-85dd-1a98117961e5.jpg?im_w=720",
        name:"Mangale",
        price: 1304,
        type:"tinyhomes",
        stars: "4.86",
        carouselPic1:  "https://a0.muscache.com/im/pictures/be5d550b-ac7d-45f1-8687-00353e811e1a.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/32b292fd-9fa2-47e4-9704-e545be95da56.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/f57ce1e7-d678-4f6d-939d-9e91d63da3e1.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/0a818cb4-0b28-4bb3-9d79-5295bcf7c52e.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/3124ab26-ff60-4d7c-951b-6c40d7b0f57d.jpg?im_w=720",
        location:"france",
        pets:true,
    },

    
    {
        id:"64",
        homeMainPic: "https://a0.muscache.com/im/pictures/7a003d5d-fc09-415d-a38e-a2f259b90f7c.jpg?im_w=720",
        name:"Bauio",
        price: 4856,
        type:"tinyhomes",
        stars: "4.15",
        carouselPic1:  "https://a0.muscache.com/im/pictures/58c708ef-145e-4ddb-b47a-ac7a51e580e6.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/bec108f7-2e5a-46d0-aa0c-222ad6392e91.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/15e5cea3-b3ec-49b0-a39d-0a615759a1ee.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/30dc20b2-2657-41c9-b21c-07e18786ab70.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/a6a92feb-6540-4901-87d1-056bba500baf.jpg?im_w=720",
        location:"france",
        pets:false,
    },

    {
        id:"65",
        homeMainPic: "https://a0.muscache.com/im/pictures/70cbab61-4419-47f2-92ce-2a71105f4e9b.jpg?im_w=720",
        name:"Batangas",
        price: 1256,
        type:"tinyhomes",
        stars: "4.55",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-33087863/original/4c7af452-83a8-4c95-bbce-895e97c4b46e.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/f27418be-aaa4-4257-b158-1123cf9c2ec4.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/3ec55176-4f47-41b5-921b-db526575ce01.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/473719a1-d800-49eb-a526-5d48bffc1e2a.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-33087863/original/15f88350-7e81-4a59-aef1-4636b08f2d21.jpeg?im_w=720",
        location:"france",
        pets:false,
    },

    {
        id:"66",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-33978312/original/9b13a712-0cbc-4987-a0a9-107fad357674.jpeg?im_w=720",
        name:"Amder",
        price: 8560,
        type:"tinyhomes",
        stars: "4.79",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-33978312/original/90096f57-4902-4787-b2e5-787732a23acd.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-33978312/original/b132bc9c-8d2b-4cb4-b7a3-ae73ff2607bf.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/9a9b3bfe-a620-4ee3-a44f-f028389bbd94.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/3e38dc52-65ed-4fdf-99a0-ea32a5c153fb.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-33978312/original/f2d78f4a-af73-455e-b2e1-799266497b60.jpeg?im_w=720",
        location:"france",
        pets:false,
    },

    {
        id:"67",
        homeMainPic: "https://a0.muscache.com/im/pictures/77c1f77d-fb4a-425d-8ef1-33d4bdcba8d1.jpg?im_w=720",
        name:"Elnido",
        price: 5956,
        type:"tinyhomes",
        stars: "4.58",
        carouselPic1:  "https://a0.muscache.com/im/pictures/07531022-3c48-4438-88ee-c642b2557dc2.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/79bb4170-87d1-4de3-89b0-c809dc67c185.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/a198f18f-9c09-4e49-b942-d4d5990a5a39.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/dfa40dee-f916-40f9-9c04-6cd8055826ff.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/462ea63a-1245-49f8-a724-daaa61c9284c.jpg?im_w=720",
        location:"france",
        pets:false,
    },

    {
        id:"68",
        homeMainPic: "https://a0.muscache.com/im/pictures/bf039192-cc54-43bf-bab3-cb7b6367207f.jpg?im_w=720",
        name:"TamboKo",
        price: 7893,
        type:"tinyhomes",
        stars: "4.98",
        carouselPic1:  "https://a0.muscache.com/im/pictures/e8d02755-8c8a-4f1f-bc12-227156c42303.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/df8874cf-eb57-4c80-9da4-07bb6c73875a.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/646e2ef9-0076-4da7-8baf-85e8860d6261.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/c0b58ef4-3d7f-432a-bc69-959903a4eab9.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/e60ba8d2-922a-4528-9c5d-b7e418bc2795.jpg?im_w=720",
        location:"france",
        pets:false,
        couple:true,

    },

    {
        id:"69",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-7310810/original/d66533ca-b438-4f97-9c31-48ddc9c28b10.jpeg?im_w=720",
        name:"Trexlan",
        price: 9562,
        type:"tinyhomes",
        stars: "4.67",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-7310810/original/a9bcd542-ce35-4ef5-ac6f-27708834242f.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-7310810/original/3130a26f-b389-4c54-b426-2dd4e3805acb.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-7310810/original/4abb4994-172a-45fd-8025-4a6e06848bc7.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-7310810/original/38ba4fdf-e203-459b-98cb-490441b67c70.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-7310810/original/8833312a-cf55-4abb-a2b0-1c97d2a81b8c.jpeg?im_w=720",
        location:"france",
        pets:false,
        couple:true,

    },

    // tab 6 i.e design

    
    {
        id:"70",
        homeMainPic: "https://a0.muscache.com/im/pictures/321a1e3a-2827-46f8-8966-9910c9678ca8.jpg?im_w=720",
        name:"Colava",
        price: 5725,
        type:"design",
        stars: "4.96",
        carouselPic1:  "https://a0.muscache.com/im/pictures/5e51dcbb-6572-435b-aae0-a8a484748f21.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/5191dfd3-c209-4c93-b395-f562b9edc198.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/712e96eb-6517-4704-b443-d4f93a45a85a.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/9680085e-def2-4c16-90cb-4b10e519454a.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/ff3724e2-222b-4d01-b40d-8a95726ce01c.jpg?im_w=720",
        location:"france",
        pets:false,
        couple:true,

    },

    {
        id:"71",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/3ae97076-6969-49da-8a20-f461b4b86903.jpeg?im_w=720",
        name:"Candolim",
        price: 7582,
        type:"design",
        stars: "4.94",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/ef2d3504-93df-49ed-8477-5b9a2b080037.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/ac993a19-97c9-4b9b-b1a1-1dcd30215049.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/65b2bee2-6ced-45e3-9f76-6fb9e1022fc2.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/b5a61252-ec39-46b3-80d4-87efa5e15e16.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-52800305/original/a0805e2a-339e-4a9d-9086-3e73163ff36c.jpeg?im_w=720",
        location:"kyiv",
        pets:true,
    },

    
    {
        id:"72",
        homeMainPic: "https://a0.muscache.com/im/pictures/981afb1a-07d1-42c8-9c65-1ca842f6de6a.jpg?im_w=720",
        name:"Matata",
        price: 8452,
        type:"design",
        stars: "4.84",
        carouselPic1:  "https://a0.muscache.com/im/pictures/ad8bb103-8eb9-4403-9381-501a9e8e3053.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/a51605ae-48b0-4782-982a-dbb77a057b58.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/527ca877-1e17-411d-af8f-69d3651dafd1.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/b65120e7-ba59-4fcd-8df0-42849e072a39.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/a1339bdd-ea92-4127-893d-721e60d1da9c.jpg?im_w=720",
        location:"kyiv",
        pets:true,
    },

    {
        id:"73",
        homeMainPic: "https://a0.muscache.com/im/pictures/0cc71977-6c16-4f16-9462-205b152b44f6.jpg?im_w=720",
        name:"Colva",
        price: 3500,
        type:"design",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/ec6a643e-3f9c-4e2d-98a0-09b1f5f26f4b.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/7312e052-de8e-4a5b-872f-f1bce5e0b670.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/16d3733d-d472-4daf-a873-8ee5b74ab3c5.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/348e0dd5-7f90-4b88-8219-ae60eb0717ed.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/5fee595d-910c-4cfc-9174-727560b40263.jpg?im_w=720",
        location:"kyiv",
        pets:true,
    },

    {
        id:"74",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/8aec4c00-ae4b-4432-82e6-adcd7f462a74.jpeg?im_w=720",
        name:"Benaulia",
        price: 8750,
        type:"design",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/d7e1f632-4882-4bee-aa94-c19fc9440a9f.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/e9d024a6-2c90-4786-8d2a-303df05f30a4.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/5e78c5b6-38a9-4692-b3dd-41b42409182b.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/7964798e-a499-4eb7-9249-45b43232ef88.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-54151380/original/b48927ce-4538-464f-93a8-fa557d657069.jpeg?im_w=720",
        location:"kyiv",
        pets:false,
    },

    {
        id:"75",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/8fe3b3d4-b0bd-4aff-9836-0805244590e4.jpeg?im_w=720",
        name:"Calangute",
        price: 6300,
        type:"design",
        stars: "3.8",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/20d43aeb-b30c-4d9c-9c2c-d62ade05d117.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/f9c505c2-865b-4e2a-96f0-003ff760f6cd.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/2b40593e-96e9-49d7-bb75-f8ed746c1b5e.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/f9ef5ea3-4f8d-4fd8-93f6-83a439c2e9e4.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/9847b513-fbd4-4548-a667-ac3daaaded66.jpeg?im_w=720",
        location:"kyiv",
        pets:false,
    },

    
    {
        id:"76",
        homeMainPic: "https://a0.muscache.com/im/pictures/3d8b4db2-0bc3-4bf7-91d7-0d34dd2bb903.jpg?im_w=720",
        name:"Norgod",
        price: 8050,
        type:"design",
        stars: "4.2",
        carouselPic1:  "https://a0.muscache.com/im/pictures/4c3ed092-cd1a-4661-ac41-f4bae8527044.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/96f83ec9-7b0f-4345-814c-f7464f3ddd04.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/5e4fb4a1-30c7-485f-8ae2-4c7fa8f902d7.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/43dce28d-5028-4fd6-b01e-7c84f80661d0.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-545403517134333906/original/9847b513-fbd4-4548-a667-ac3daaaded66.jpeg?im_w=720",
        location:"kyiv",
        pets:false,
    },

    {
        id:"77",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/0baf5958-7293-48df-9c25-3c5d23c1f297.jpeg?im_w=720",
        name:"NeeurlPea",
        price: 4580,
        type:"design",
        stars: "4.87",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/d953812b-fd01-4732-9dd4-84240eacbdac.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/6ba6a13a-7de8-4d74-8593-aaf5f736a61c.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/becb9817-ee32-42eb-824d-f5ac4ee3e31b.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/83683b42-999a-4ca3-9db3-c56f8da0ed55.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-53962843/original/7b5cca14-b624-4314-a7cc-f59d92839317.jpeg?im_w=720",
        location:"kyiv",
        pets:false,
    },

    {
        id:"78",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/3d515645-215b-40bc-8edc-d086fdbd182d.jpeg?im_w=720",
        name:"Loutotlim",
        price: 7850,
        type:"design",
        stars: "4.47",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/59f59a30-e692-47fa-9dc0-7bf8e100c18b.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/709a250b-3e07-48ab-ac8f-4609739997e3.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/29eba09c-addd-4387-927a-93b53734f046.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/d4bac09d-9d47-414f-82ab-728f7cdc3a9b.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-22540306/original/51831d57-edd4-4c50-b804-6468fb766bb3.jpeg?im_w=720",
        location:"kyiv",
        pets:false,
        couple:true,

    },

    {
        id:"79",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/227ad5c1-8855-4370-9f9a-97034281c3e2.jpeg?im_w=720",
        name:"Betatime",
        price: 7850,
        type:"design",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/7090cc2a-27e8-45d7-a825-0b1854145e25.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/fe4bd8db-8d59-40ff-8629-9314a3359a3b.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/64598820-934a-4f1a-b19f-b6bcbfb17810.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/32b426ec-405e-4c21-94f7-f55d32287cce.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-39934917/original/bf8a0b70-fa2b-4ebd-8502-43a3658bae84.jpeg?im_w=720",
        location:"kyiv",
        pets:false,
        couple:true,

    },

    {
        id:"80",
        homeMainPic: "https://a0.muscache.com/im/pictures/5b4d3ab2-bae2-4c82-b05a-83467a5b076e.jpg?im_w=720",
        name:"Noshdan",
        price: 4782,
        type:"design",
        stars: "4.56",
        carouselPic1:  "https://a0.muscache.com/im/pictures/33c63039-6e52-4bf9-873a-ec39061e2c88.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/a5023daa-037e-4a82-b746-51a882781c32.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/8fe1fef2-d2e6-4c44-9729-a763e38bb666.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/fa15f4e2-8ee2-4b51-8057-78009947a0da.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/c4731a81-c2b6-4646-85e2-12b8a001c79b.jpg?im_w=720",
        location:"kyiv",
        pets:false,
        couple:true,

    },

    {
        id:"81",
        homeMainPic: "https://a0.muscache.com/im/pictures/1e36056e-2f67-4ad9-aa39-0547b2cfaeff.jpg?im_w=720",
        name:"Sangchi",
        price: 5800,
        type:"design",
        stars: "4.76",
        carouselPic1:  "https://a0.muscache.com/im/pictures/4af87cc3-3d31-41c3-9b5e-f436535bf4e7.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/c1771c68-5f05-4a59-9449-76ea725b6ec0.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/617bbc92-658b-4f10-9565-e14373ad2d40.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/118f979e-d9c7-4620-be03-18c81d3883a3.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/fb38e48e-b2da-4694-a553-2ba51bcf8f69.jpg?im_w=720",
        location:"usa us",
        pets:true,
    },

    {
        id:"82",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-671456595560845798/original/880f54ce-51c7-44ed-903f-d9b11f674707.jpeg?im_w=720",
        name:"Neurl",
        price: 7490,
        type:"design",
        stars: "4.26",
        carouselPic1:  "https://a0.muscache.com/im/pictures/d8da6b20-941a-4214-af21-737cf29b308a.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/c2247faf-d96b-4d17-b328-ab9a6356aa75.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-40214539/original/73b81efc-e658-4eba-a488-9b3b658c1b4e.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/ff25b7e5-0fb7-4f45-9fc3-63bf5ac251af.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/0f2bfb30-6951-4e93-b2e7-0015a80d91b4.jpg?im_w=720",
        location:"usa us",
        pets:true,
    },

    
    {
        id:"83",
        homeMainPic: "https://a0.muscache.com/im/pictures/7e44319c-704f-4345-8bce-4601c893ed16.jpg?im_w=720",
        name:"Nilofer",
        price: 5060,
        type:"design",
        stars: "4.86",
        carouselPic1:  "https://a0.muscache.com/im/pictures/09667e04-d6d4-455e-afe2-a7ba2427a683.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/ac63eb86-504c-4438-8f25-26c27778734d.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/03967072-9fcb-4072-a36d-cb9f677b0ff6.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/86ba0630-3d48-4e71-82f0-c5551f271fa9.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/343f76e7-434e-4090-82f3-da5f6a229a29.jpg?im_w=720",
        location:"usa us",
        pets:true,
    },

    {
        id:"84",
        homeMainPic: "https://a0.muscache.com/im/pictures/a40a31ef-1a1a-4044-94bf-2d9a1c71b2b3.jpg?im_w=720",
        name:"Aura",
        price: 8200,
        type:"design",
        stars: "4.86",
        carouselPic1:  "https://a0.muscache.com/im/pictures/14c70a65-fd0f-465b-b698-54787d7ea262.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-28292714/original/6c0c70d4-5e3b-41df-80f6-9ab0a8b3be4a.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-28292714/original/d7b8e599-14a7-404d-a8c7-fee82a34270b.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-28292714/original/e778a24f-d500-413c-b731-e15b9244ea12.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-28292714/original/5a737bcb-32db-4d8f-aedb-e707fae42a41.jpeg?im_w=720",
        location:"usa us",
        pets:false,
    },


    // Tab 7 i.e islands
    {
        id:"85",
        homeMainPic: "https://a0.muscache.com/im/pictures/e25a9b25-fa98-4160-bfd1-039287bf38b6.jpg?im_w=720",
        name:"Abiansemal",
        price: 500,
        type:"islands",
        stars: "4.88",
        carouselPic1: "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/f4f7b242-db33-46fc-9080-c3d6a6fd55ec.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/372e7d6f-7fb9-4668-92f0-25bb9a346814.jpeg?im_w=720 ",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/4756e699-f474-4ca7-8b77-06b12715a6cb.jpeg?im_w=720 ",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/fca892a4-3481-4ad1-9f92-404feaa42e9f.jpeg?im_w=720 " ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-34113796/original/36d8007a-0de5-439d-9fec-1c2d7b53a147.jpeg?im_w=720",
        location:"usa us",
        pets:false,
    },

    {
        id:"86",
        homeMainPic: "https://a0.muscache.com/im/pictures/0b25f6b3-f215-4938-ac81-581eb3929047.jpg?im_w=720",
        name:"Balian Beach",
        price: 400,
        type:"islands",
        stars: "4.84",
        carouselPic1: "https://a0.muscache.com/im/pictures/7cc3c855-f90e-4d0f-9b13-3b5c2a3c4bad.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/9833de62-35b7-41f2-8a24-0d9354150ea7.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/de73abc2-5dc9-4962-ba32-5d28211cdde0.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/92d22326-8207-4357-951b-35dab300db95.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/f52d2902-c301-400f-84c9-373efa448854.jpg?im_w=720",
        location:"usa us",
        pets:false,
    },

    {
        id:"87",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/bb35bfcf-f276-4e00-a0d1-73b319b2a9cd.jpeg?im_w=720",
        name:"Ubud Mansion",
        price: 200,
        type:"islands",
        stars: "4.64",
        carouselPic1: "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/1854bf1b-dc40-49ed-9c2e-d378663a7a02.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/da951ef9-3fed-4c15-b4b8-2cd5b24357a9.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/ce7599e7-5560-4bed-9fc5-c0bc82d70fd0.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/5612048a-ab35-4ca5-81e8-646d2f7a2b3c.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-47721565/original/8983f2dc-6d79-48a6-8f8f-656fda0982a4.jpeg?im_w=720",
        location:"usa us",
        pets:false,
    },

    {
        id:"88",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/ab9a30d4-a6cf-4b3a-8416-cf7314ed5432.jpeg?im_w=720",
        name:"Selat Mansion",
        price: 2000,
        type:"islands",
        stars: "4.94",
        carouselPic1: "https://a0.muscache.com/im/pictures/f2a6d022-23fc-4701-b703-806870cd9ed7.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/b0385f97-cc39-4f12-980a-05d561cc19a3.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/411c07b5-c03b-4bf7-a0fc-65ea439be452.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/40036a49-6fc1-45f4-9988-9f49c26c902a.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-5904771/original/e8429c29-d29b-4333-ae9f-4163265429fc.jpeg?im_w=720",
        location:"usa us",
        pets:false,
        couple:true,

    },

    {
        id:"89",
        homeMainPic: "https://a0.muscache.com/im/pictures/4f70b681-a792-4530-8c52-f2a8d262942d.jpg?im_w=720",
        name:"Selat Mansion",
        price: 2000,
        type:"islands",
        stars: "4.94",
        carouselPic1: "https://a0.muscache.com/im/pictures/e15ee353-0861-44ed-868a-56091755e513.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/45a3aa2b-ce00-4068-9ebe-9f83ca281fe4.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-43629767/original/ec85ccc0-281c-44fc-a061-bc1e87ea0081.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/f474dfbe-557a-4d07-8d6e-76aba506b5a6.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/0c37c239-fe53-4ae5-9e70-34d3988342da.jpg?im_w=720",
        location:"usa us",
        pets:false,
        couple:true,

    },

    {
        id:"90",
        homeMainPic: "https://a0.muscache.com/im/pictures/prohost-api/Hosting-46761225/original/11058c0d-fac8-4035-8f16-8b3abe7441cd.jpeg?im_w=720",
        name:"Kekamatan Ubud",
        price: 5000,
        type:"islands",
        stars: "4.54",
        carouselPic1: "https://a0.muscache.com/im/pictures/prohost-api/Hosting-46761225/original/08ca9cc1-6c85-4663-9faa-114e1c00956e.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/31a82697-b77d-4e79-aa4f-cfdb65f967ec.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-46761225/original/797d317f-a624-40eb-99de-2f3219176317.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-46761225/original/762acbae-692b-4054-b49e-0970f83feda3.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/5564847a-c678-4e39-8de1-2f591d017657.jpg?im_w=720",
        location:"usa us",
        pets:false,
        couple:true,

    },

    {
        id:"91",
        homeMainPic: "https://a0.muscache.com/im/pictures/ab61d106-3c6e-4f4f-a9d6-3f16cfa3eaeb.jpg?im_w=720",
        name:"Banjar Kutukh Kaja",
        price: 500,
        type:"islands",
        stars: "4.84",
        carouselPic1: "https://a0.muscache.com/im/pictures/ddfe37fc-ffd9-463e-a662-6239b251384b.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/1b697e43-ddb6-4df6-b753-d9be5ec4ceb5.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/a7b0e74c-01ed-4be2-a5af-7e9fcffe64a6.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/b34ec56f-3040-4f04-98a1-c37af9351b92.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/e120ceab-9202-41c2-ac07-58ea082eef8b.jpg?im_w=720",
        location:"spain",
        pets:true,
    },

    {
        id:"92",
        homeMainPic: "https://a0.muscache.com/im/pictures/4a5c629b-9c92-450e-8d8f-995875798838.jpg?im_w=720",
        name:"Tampakasirirng",
        price: 9000,
        type:"islands",
        stars: "4.97",
        carouselPic1: "https://a0.muscache.com/im/pictures/08a9afde-e2f2-48aa-b8b0-a7e747318943.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/0295e1cd-09fe-448a-b837-7bf5ade3809c.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/b51f509a-9c94-4d1c-a31c-1a465e1670ac.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/6d3f81b5-affa-4c13-8681-4081d2568be6.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/42c0bbcb-29e5-4064-adad-6382393dce0f.jpg?im_w=720",
        location:"spain",
        pets:true,
    },

    {
        id:"93",
        homeMainPic: "https://a0.muscache.com/im/pictures/4ca0a7e5-9777-4ba6-9fce-8a0a94bbe555.jpg?im_w=720",
        name:"Uluwatu",
        price: 1200,
        type:"islands",
        stars: "4.75",
        carouselPic1:  "https://a0.muscache.com/im/pictures/ca3de64a-addf-40dc-a368-c272ddd9b2bc.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/bb595700-650e-4db1-9ae7-9688b46628d1.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/a29a3aed-a774-44b8-93ea-98698d481a4e.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/9b72d952-fa69-4ab6-a95d-9fd88a06c879.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/208e78d4-9e16-4916-aff5-4392e8185607.jpg?im_w=720",
        location:"spain",
        pets:true,
    },

    {
        id:"94",
        homeMainPic: "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/801785b8-64d5-45d3-a25d-a5f62cdf2ed2.jpeg?im_w=720",
        name:"Kecamatana",
        price: 8000,
        type:"islands",
        stars: "4.45",
        carouselPic1:  "https://pkslist.azureedge.net/media/images/1/31214da3-6911-4f36-bf03-97e37d5e7164/800x600.jpg",
        carouselPic2 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/79cca65b-4fe8-444e-94c8-48987b61164a.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/9db32a8a-8b56-4157-92a4-8a39bb3d944f.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/14309683-a315-4677-a92b-7824d7027b9e.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-44970955/original/837c0387-847d-49f5-bae9-91572284b822.jpeg?im_w=720",
        location:"spain",
        pets:false,
    },

    {
        id:"95",
        homeMainPic: "https://a0.muscache.com/im/pictures/6d90bd2d-1bae-47cc-b831-b7561d766048.jpg?im_w=720",
        name:"Seirit",
        price: 5000,
        type:"islands",
        stars: "4.72",
        carouselPic1:  "https://a0.muscache.com/im/pictures/26bfb0b8-27a2-45d2-8021-9ffc2d28d6c1.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/b30f5628-79ff-4e48-b600-8c515f72dde5.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/f2026c2f-028b-4a4f-895d-2fea973d9609.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/582c5bd6-65b1-41e3-83d5-97d75d45aab7.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/588a6c44-4a6a-4812-bf5b-fa8925f17271.jpg?im_w=720",
        location:"spain",
        pets:false,
    },

    {
        id:"96",
        homeMainPic: "https://a0.muscache.com/im/pictures/81aaba9d-ec2b-4f83-ab67-1f4c6dbccc17.jpg?im_w=720",
        name:"Kambalo",
        price: 1650,
        type:"islands",
        stars: "4.98",
        carouselPic1:  "https://a0.muscache.com/im/pictures/34bf6c0e-655e-4ab7-b569-d7e234a06c17.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/757e92e9-9a2d-4972-80eb-57665aeb9c55.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/d7dfc560-6dd2-4c6c-86ba-c238997848c2.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/c08997f4-625c-4d31-a8cf-3a579456774e.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/dad47893-747f-406c-8697-7efa1f263d47.jpg?im_w=720",
        location:"spain",
        pets:false,
    },

    {
        id:"97",
        homeMainPic: "https://a0.muscache.com/im/pictures/881f0d54-6449-402a-8ffe-499664d302bf.jpg?im_w=720",
        name:"Mengwi",
        price: 1500,
        type:"islands",
        stars: "4.58",
        carouselPic1:  "https://a0.muscache.com/im/pictures/fa9aa1b5-3e63-4e1c-863d-5e63702794da.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/d84bccce-0567-4b47-a165-f7a22219aab4.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/75333e4f-4519-4897-9a8a-c0afbba7ce87.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/4ab0201a-00e9-44b6-8888-1ed553e36dc1.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/43e423f2-5b07-4f4b-a9e5-7fa8633154fc.jpg?im_w=720",
        location:"spain",
        pets:false,
    },

    {
        id:"98",
        homeMainPic: "https://a0.muscache.com/im/pictures/monet/Luxury-20470768/original/cc213ade-c939-4e2f-b0af-0149bda85030?im_w=720",
        name:"Samaui",
        price: 1500,
        type:"islands",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/6d3bd191-b013-4cf9-b297-5f3c253acadf.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/84242eab-0733-43a0-bea6-8934b62df1cf.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/1a62d125-294d-4ea8-ac01-8fdcd65f85da.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/1900a5c5-4f54-4bff-af26-1c102e4bcd45.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/83eda27f-50be-4356-8d74-0c40ef73226a.jpg?im_w=720",
        location:"spain",
        pets:false,
        couple:true,

    },

    
    {
        id:"99",
        homeMainPic: "https://a0.muscache.com/im/pictures/06d92669-7b0e-4e09-a001-00b5f956d619.jpg?im_w=720",
        name:"Kubata",
        price: 8500,
        type:"islands",
        stars: "4.62",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-17700584/original/2f78f22e-1fe9-4ec6-b5fc-31551dc33b2d.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/84242eab-0733-43a0-bea6-8934b62df1cf.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/1a62d125-294d-4ea8-ac01-8fdcd65f85da.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/1900a5c5-4f54-4bff-af26-1c102e4bcd45.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/83eda27f-50be-4356-8d74-0c40ef73226a.jpg?im_w=720",
        location:"spain",
        pets:false,
        couple:true,

    },

    // Tab 8 i.e view

    
    {
        id:"100",
        homeMainPic: "https://a0.muscache.com/im/pictures/2d8ea58a-bb1c-4145-9f48-94fcbaafc8a6.jpg?im_w=720",
        name:"Badungr",
        price: 6650,
        type:"view",
        stars: "4.25",
        carouselPic1:  "https://a0.muscache.com/im/pictures/08b70c1e-c97d-480b-8798-dcc6e49b07be.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/8357e216-0b4f-43dd-bd12-002ba8f5e8ea.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/c90703e9-ec45-4f56-ab90-cff407998cbe.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/b14eb182-33e3-4294-915e-c4b07fc93f7f.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/7eeca0cf-90e1-468a-beba-a64251b2e109.jpg?im_w=720",
        location:"spain",
        pets:false,
        couple:true,

    },

    {
        id:"101",
        homeMainPic: "https://a0.muscache.com/im/pictures/e44d6ea0-d174-4024-9fac-c254c55b1221.jpg?im_w=720",
        name:"SagoFil",
        price: 4500,
        type:"view",
        stars: "4.85",
        carouselPic1:  "https://a0.muscache.com/im/pictures/4af87cc3-3d31-41c3-9b5e-f436535bf4e7.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/c1771c68-5f05-4a59-9449-76ea725b6ec0.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/617bbc92-658b-4f10-9565-e14373ad2d40.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/118f979e-d9c7-4620-be03-18c81d3883a3.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/fb38e48e-b2da-4694-a553-2ba51bcf8f69.jpg?im_w=720",
        location:"italy",
        pets:true,
    },

    
    {
        id:"102",
        homeMainPic: "https://a0.muscache.com/im/pictures/a98abbe7-615f-45a9-a614-37910e7e909e.jpg?im_w=720",
        name:"Cancona",
        price: 4800,
        type:"view",
        stars: "4.87",
        carouselPic1:  "https://a0.muscache.com/im/pictures/fe9e0540-4750-41e1-9135-729cb1c61340.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/7e941d32-dd35-40e3-b8c9-693e04c39682.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/ad25f1ec-ca77-48fa-aa91-82b133e6621d.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/2383e199-b0d1-45b9-b003-359172534abc.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/5b88976e-873b-4126-9bc2-7197434d40cb.jpg?im_w=720",
        location:"italy",
        pets:true,
    },

    
    
    {
        id:"103",
        homeMainPic: "https://a0.muscache.com/im/pictures/957489e8-c915-4208-a99d-c75334d5d58e.jpg?im_w=720",
        name:"Loutulim",
        price: 8800,
        type:"view",
        stars: "4.91",
        carouselPic1:  "https://a0.muscache.com/im/pictures/6c4f0013-6650-4184-9b6d-083cc254d45f.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/72182496-2965-45ba-9858-1bf06a03b8d1.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/d1c2e3bd-aebe-4fcf-b91f-f0bc557666f1.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/891736e3-a1b3-461c-895c-65f5ebc22ada.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/bd68eb62-b199-4f18-a9e4-5f7ca590d168.jpg?im_w=720",
        location:"italy",
        pets:true,
    },

    {
        id:"104",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/6316e9f3-9f94-43b0-8d84-30e0a9516663.jpeg?im_w=720",
        name:"Panji",
        price: 6752,
        type:"view",
        stars: "4.85",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/f6a7ecab-e303-49cb-8e3d-46c5bed00001.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/dc962781-52af-4394-b5d1-305303eda44f.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/47e80e89-ed7d-44c8-aa58-e474e89c9efa.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/7ca45d8b-ceb8-49c0-9f0c-a9953a8801e6.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-49022230/original/9aae2290-471b-4e5c-ab2a-159c5c79ca80.jpeg?im_w=720",
        location:"italy",
        pets:true,
    },

    {
        id:"105",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/ca837f4e-fc63-4de8-8abd-d867f5045196.jpeg?im_w=720",
        name:"Colava",
        price: 9800,
        type:"view",
        stars: "4.8",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/c3d940b1-8aa2-423b-b38d-e6fdc94833c0.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/777e902a-8d7d-405a-80ca-97f89749b91e.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/04398ee5-0e48-462a-86a0-a3801bad2172.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/ca837f4e-fc63-4de8-8abd-d867f5045196.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-50867469/original/49cddd92-0663-4ec8-8272-43f207fcfd4f.jpeg?im_w=720",
        location:"italy",
        pets:false,
    },

    {
        id:"106",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-45796358/original/aa1e124c-81b9-4d7b-9707-51fe7ce9658d.jpeg?im_w=720",
        name:"Varca",
        price: 8475,
        type:"view",
        stars: "4.93",
        carouselPic1:  "https://a0.muscache.com/im/pictures/27206bd1-e7c8-4e6c-a821-df71e5cc884a.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/9334fc54-f39c-4142-85ad-d9bd9d171e2d.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-45796358/original/906b57d5-25a6-4dcb-884b-2d9dca6de7bc.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-45796358/original/aa387941-f79c-4737-8b7f-db42ae8f8df6.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-45796358/original/4ed4eb30-1917-4f20-9f1c-95619ccf6682.jpeg?im_w=720",
        location:"italy",
        pets:false,
    },

    {
        id:"107",
        homeMainPic: "https://a0.muscache.com/im/pictures/c25c9546-5a2e-4092-bbae-d294836014e2.jpg?im_w=720",
        name:"Mandel",
        price: 5975,
        type:"view",
        stars: "4.93",
        carouselPic1:  "https://a0.muscache.com/im/pictures/5fd5a247-7ab4-4e71-abbb-fd1b331770d4.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/770c5620-568d-44cc-84ee-5d99c052dd23.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/ca82c468-aeec-4550-bc44-ba69f6883f18.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/7db2eaa3-60ed-4332-9633-7650e208d7a1.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/fdcb4dd6-d48d-4e1b-9f0a-dc01cadeef91.jpg?im_w=720",
        location:"italy",
        pets:false,
    },

    {
        id:"108",
        homeMainPic: "https://a0.muscache.com/im/pictures/a93e9798-69cd-48d3-a7a0-1753e31bb60b.jpg?im_w=720",
        name:"Babek",
        price: 4975,
        type:"view",
        stars: "4.43",
        carouselPic1:  "https://a0.muscache.com/im/pictures/9851d648-50cd-4a01-84a5-c55a5b6f6c73.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-39564407/original/12622023-1277-432c-b923-b6ea574ca83d.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-39564407/original/db725b5d-05b2-4363-97e3-96dde878d379.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-39564407/original/66f7feff-3c16-4439-9ba4-832cfdcbca72.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/050244f0-23e1-47d8-8c30-1c1c4be9e030.jpg?im_w=720",
        location:"italy",
        pets:false,
        couple:true,

    },

    
    {
        id:"109",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/75594cf3-d551-485c-9a2d-2f735b9a75f4.jpeg?im_w=720",
        name:"Daramob",
        price: 7825,
        type:"view",
        stars: "4.37",
        carouselPic1:  "https://a0.muscache.com/im/pictures/01376579-dae6-4f03-a9f6-b7c7b91ca681.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/75b18059-523c-4c8f-b67f-704ec9b342be.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/a99e41e5-1aed-49e3-b2ce-2d0e00e9d76f.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/779675f8-2c82-43e3-858b-ab81fe15f737.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/cd53984e-0366-497c-a9da-9363c95bdcd2.jpg?im_w=720",
        location:"italy",
        pets:false,
        couple:true,

    },

    {
        id:"110",
        homeMainPic: "https://a0.muscache.com/im/pictures/73b21cbb-5c7f-47ce-850b-bdb85e5d2133.jpg?im_w=720",
        name:"Colva",
        price: 4664,
        type:"view",
        stars: "4.57",
        carouselPic1:  "https://a0.muscache.com/im/pictures/38ee6fc8-bdd8-43e1-9b34-e3ef4edd68d4.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/8b40260f-c4f1-46e4-b93a-45bb6cd1840b.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/9fb6a440-290f-4c0c-becf-0cea63358278.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-548838707677454931/original/779675f8-2c82-43e3-858b-ab81fe15f737.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/cd53984e-0366-497c-a9da-9363c95bdcd2.jpg?im_w=720",
        location:"italy",
        pets:false,
        couple:true,

    },

    {
        id:"111",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/537432f3-ff14-403a-9088-2fa4521b59c8.jpeg?im_w=720",
        name:"Nigdmah",
        price: 6864,
        type:"view",
        stars: "4.87",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/e348b1cc-1bed-4c0f-88f2-21c421d452f4.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/2a637d8d-40e4-4b79-abcb-82f4a3bc9a78.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/52bb6a56-6001-4812-a4c3-753fe697173d.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/a08e1a30-a20d-4fb1-a985-c9d8ab65b579.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/0562e372-9762-45af-97c6-eb658b38e412.jpeg?im_w=720",
        location:"canada",
        pets:true,
    },

    {
        id:"191",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/e348b1cc-1bed-4c0f-88f2-21c421d452f4.jpeg?im_w=720",
        name:"Nigdmah",
        price: 6864,
        type:"view",
        stars: "4.87",
        carouselPic1: "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/537432f3-ff14-403a-9088-2fa4521b59c8.jpeg?im_w=720" ,
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/2a637d8d-40e4-4b79-abcb-82f4a3bc9a78.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/52bb6a56-6001-4812-a4c3-753fe697173d.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/a08e1a30-a20d-4fb1-a985-c9d8ab65b579.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-622752020421080917/original/0562e372-9762-45af-97c6-eb658b38e412.jpeg?im_w=720",
        location:"canada",
        pets:true,
    },

    
    {
        id:"112",
        homeMainPic: "https://a0.muscache.com/im/pictures/deaf6622-8244-4059-a791-ae9256a58f1a.jpg?im_w=720",
        name:"Orlim",
        price: 4935,
        type:"view",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/5de25524-6815-4f97-81b0-6990531285ab.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-53484390/original/41bd01b2-b376-4a87-82bd-534471399d7a.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/3e307ee0-6750-474c-b07f-151a50140a79.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/a3639494-a256-4804-a67b-32ac9c2f8551.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/69d1e422-9e7c-4b3f-8772-7e50df9e16c8.jpg?im_w=720",
        location:"canada",
        pets:true,
    },
    
    {
        id:"113",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/26f963d2-1ca1-4b6e-89c8-229e6d960675.jpeg?im_w=720",
        name:"Utora",
        price: 8965,
        type:"view",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/b13f14f7-6fa2-4f9e-9b77-dfca3c673634.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/56499391-b902-4b07-a6c5-b7479debb3d2.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/10b01df3-5487-417b-90b9-d102d33b61d5.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-53933565/original/402a072f-91b9-4467-8e69-c7c5a3519646.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/69d1e422-9e7c-4b3f-8772-7e50df9e16c8.jpg?im_w=720",
        location:"canada",
        pets:true,
    },

    {
        id:"114",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-52743271/original/58716c75-1031-401a-990f-ad644e054259.jpeg?im_w=720",
        name:"Habiora",
        price: 8965,
        type:"view",
        stars: "4.85",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-52743271/original/3f305981-7cdf-464d-9e3d-494fed3528d9.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-52743271/original/4baec95d-148e-4635-8eba-852f91b9f19d.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-52743271/original/4bcc3d88-dbb7-4ca5-8940-7b106678ac85.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/68050026-d4a0-4fb8-b89d-a5d80a881940.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/a82a6ebf-9d6b-4d8d-9a4a-2dd9a72a18df.jpg?im_w=720",
        location:"canada",
        pets:false,
    },

    // Tab 9 i.e COUPLE

    
    {
        id:"115",
        homeMainPic: "https://a0.muscache.com/im/pictures/c7fdf7b1-4624-42e0-ab9c-5c002bc04c02.jpg?im_w=720",
        name:"Caluengete",
        price: 3820,
        type:"couple",
        stars: "4.88",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-46228387/original/e3304144-a0bd-4c1c-a1f0-37b18261b35b.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/ed085b52-a71b-417a-81bb-bebaf5ba83ca.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-46228387/original/f72773a3-aad2-44bd-bcee-d381b906f6f0.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/82e8b194-8d7d-45cd-939b-4395300e1b2c.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/024407cb-22e1-43b1-a6e6-5673c553d82a.jpg?im_w=720",
        location:"canada",
        pets:false,
    },

    {
        id:"116",
        homeMainPic: "https://a0.muscache.com/im/pictures/58ea01f6-762a-4730-9106-92b463d2b255.jpg?im_w=720",
        name:"Aqua",
        price: 7850,
        type:"couple",
        stars: "4.58",
        carouselPic1:  "https://a0.muscache.com/im/pictures/9932a298-6b1c-4c96-b2c8-df85f319c44a.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/30c89fc8-dc65-488c-bb12-3bbc3bab2070.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/f8c88457-1b72-4b4f-a811-8f6217dc20b6.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/00e695c6-001c-4876-a786-6278289fea5e.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/8a682100-6af3-425a-a5a0-831fae9e196a.jpg?im_w=720",
        location:"canada",
        pets:false,
    },

    {
        id:"117",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/ce12769c-4d54-4ac3-8db0-f7530aa88144.jpeg?im_w=720",
        name:"Vagator",
        price: 1050,
        type:"couple",
        stars: "4.88",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/d7768904-e0e1-4867-9022-7e80c192e74d.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/a11a084b-84c0-4850-ad2b-8c2002318171.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/6b88d7c9-f873-42d3-b4b6-2fea3a176a18.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-16258047/original/b1280db1-aae5-4586-8389-5eb3dfb02b83.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/26386ced-5f26-4cc8-a0d5-cead091c1422.jpg?im_w=720",
        location:"canada",
        pets:false,
        couple:true,

    },

    {
        id:"118",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/347ab2a7-537a-4c1c-9d22-ae7af0319c17.jpeg?im_w=720",
        name:"Cancona",
        price: 2255,
        type:"couple",
        stars: "4.98",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/810a217b-b081-48a0-974d-db0ee77e95c5.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/d46de5b9-5207-4ea1-8cbf-aa1169dba64c.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/47a03d51-f249-46f4-92f5-3bc9a970d2e0.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/f6ba5dfe-139d-4563-9c29-a6515467179f.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-53693912/original/347ab2a7-537a-4c1c-9d22-ae7af0319c17.jpeg?im_w=720",
        location:"canada",
        pets:false,
        couple:true,

    },

    {
        id:"119",
        homeMainPic: "https://a0.muscache.com/im/pictures/5314255c-ea99-4b29-9a5c-1ae56f3d9f37.jpg?im_w=720",
        name:"Panjali",
        price: 1885,
        type:"couple",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/d42c3708-0767-45c2-afec-48f58ae5f37b.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/6594e7fa-99ad-4641-b9ec-29df3665be4f.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/b51588c7-84e5-4b7a-94db-b0220ebb325d.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/44cdb32e-02fc-4970-8a30-5d6ddaf9a623.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/4062779b-8434-4e07-84f7-32e5d4c37cdb.jpg?im_w=720",
        location:"canada",
        pets:false,
        couple:true,

    },

    
    {
        id:"120",
        homeMainPic: "https://a0.muscache.com/im/pictures/0df3b66e-b1e2-4bca-9c2b-300c28926569.jpg?im_w=720",
        name:"Coladre",
        price: 7895,
        type:"couple",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/23052913-099c-4a3a-8f69-dddc2734782c.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/ff4f00ab-b2f2-403b-acd9-65e9dff0dced.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/169b4678-f038-427d-b3b9-06348af8f20c.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/7e121fdf-100d-4ab5-b323-7a9917db465c.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/prohost-api/Hosting-45731930/original/bffdd0b5-271e-4836-8607-57efad2e70bb.jpeg?im_w=720",
        location:"australia",
        pets:true,
    },

    {
        id:"121",
        homeMainPic: "https://a0.muscache.com/im/pictures/prohost-api/Hosting-45731930/original/bffdd0b5-271e-4836-8607-57efad2e70bb.jpeg?im_w=720",
        name:"Mandela",
        price: 7890,
        type:"couple",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/e29175b2-3cd2-4f9a-bb9b-7630317ba2bc.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/266291b1-f23d-4c90-8e71-5dac0acba81d.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/1efa86a3-adbe-47f4-ab26-fe4484568c4a.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/2e52d3bc-3b96-4b7f-9b6e-2f7d14d9e141.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/19bb367a-6b23-4ff4-be08-7fe5fcac1859.jpg?im_w=720",
        location:"australia",
        pets:true,
    },

    {
        id:"122",
        homeMainPic: "https://a0.muscache.com/im/pictures/79ee6640-f7c6-4775-b18f-eea593565e9d.jpg?im_w=720",
        name:"Orya",
        price: 5680,
        type:"couple",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/c92ed58a-2958-4f1b-b6bc-05e7cac92b04.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/9bf63f70-bbfa-47bc-8390-d5aaff6ec6e6.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/3d1bd274-b968-4546-a405-3e59e19a366c.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/0e28b47f-0ad1-4782-ad1a-1a86c21dfedd.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/9490dd4c-f9b6-4d42-9ca9-eaeccd019b99.jpg?im_w=720",
        location:"australia",
        pets:true,
    },

    {
        id:"123",
        homeMainPic: "https://a0.muscache.com/im/pictures/0f8822af-f738-431b-a30f-ccc8ff7f31ee.jpg?im_w=720",
        name:"Equpd",
        price: 4780,
        type:"couple",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/0750bacd-1294-4707-8ef5-25f21e5f3759.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/e2636128-eb3c-4a6a-a2ab-49aa683aabc9.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/44996549-d82e-40ab-a79e-cfe8face9a27.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/79729789-c287-4677-98b3-41eb38784ba5.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/fc9e58d7-4660-4e36-a647-b30723534424.jpg?im_w=720",
        location:"australia",
        pets:false,
    },

    {
        id:"124",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/4ab77d63-7116-41c8-957b-921209a1c0b9.jpeg?im_w=720",
        name:"Nilofouer",
        price: 7890,
        type:"couple",
        stars: "4.80",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/f532f561-f0f6-4454-a0d9-230be7a66462.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/fb41ad46-9aeb-47cd-b814-ad53847e5977.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/8681edbb-ad74-4cc6-abd9-1db639f7e599.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/1bf7e8b4-cf5c-4568-9efc-edf83ee5b820.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/29365245-0953-4840-b9d3-09498da5b7ab.jpeg?im_w=720",
        location:"australia",
        pets:false,
    },

    
    {
        id:"125",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/0e7d0e69-2edf-427b-90ae-b8245efba32c.jpeg?im_w=720",
        name:"Ora",
        price: 1145,
        type:"couple",
        stars: "4.88",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/72c66a59-a92f-4579-a1c1-40bf679ce091.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/a218e8c6-7e82-493f-9886-aac39973f73a.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/8b05417a-3a6c-41ac-abcd-ade3bda1ff64.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/4d4cc31e-fbdd-46ac-9ac1-9f2e25310d95.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-40282903/original/a08e9dab-dd58-4ceb-86c7-ca33d961d8e9.jpeg?im_w=720",
        location:"australia",
        pets:false,
    },

    {
        id:"126",
        homeMainPic: "https://a0.muscache.com/im/pictures/29a4d8ad-4ea1-4f6c-bd78-920bd3351e8a.jpg?im_w=720",
        name:"Quazi",
        price: 7450,
        type:"couple",
        stars: "4.48",
        carouselPic1:  "https://a0.muscache.com/im/pictures/276901a4-9087-44d3-94c0-d2065d2a2f8d.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/ba1071e9-a2dd-4f0d-9316-33b877dcc897.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/9a1dbb53-62f1-4d7d-98df-2ee8e56881ba.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/338e3a00-f6e1-4c15-b47d-c818bce7785b.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/14e0cf79-c731-46d7-99e9-443303e0914f.jpg?im_w=720",
        location:"australia",
        pets:false,
        couple:true,

    },

    // Tab 10 i.e arctic 

    {
        id:"127",
        homeMainPic: "https://a0.muscache.com/im/pictures/72e3dfea-2b90-4afe-a1bd-1be37e77539a.jpg?im_w=720",
        name:"Quazi",
        price: 4560,
        type:"arctic",
        stars: "4.88",
        carouselPic1:  "https://a0.muscache.com/im/pictures/61e15b47-a563-4348-b891-5106bc4ebb02.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/126374d2-69b6-4695-887f-aeee6345e7f1.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/2a4637ae-4322-4623-9475-aad69250ba90.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/67cde095-c507-4e40-a4ce-499de12e66af.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/60d4058e-98a8-4f30-ba8a-93b101a31c47.jpg?im_w=720",
        location:"australia",
        pets:false,
        couple:true,

    },

    {
        id:"128",
        homeMainPic: "https://a0.muscache.com/im/pictures/d7d362f8-40a0-4128-8f07-70572525de1a.jpg?im_w=720",
        name:"Aura",
        price: 4500,
        type:"arctic",
        stars: "4.95",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/a072b835-1a9f-4189-9493-4706414dd519.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/825371c6-0b1b-49a8-bca6-61955355b81d.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/69cc53df-0698-4292-99cc-3e7989fd0e7a.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/bac67c67-90d2-4cea-a5f4-8e37d677a645.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/9e859008-411d-4418-928a-b18a72c34d3d.jpeg?im_w=720",
        location:"australia",
        pets:false,
        couple:true,

    },

    
    {
        id:"129",
        homeMainPic: "https://a0.muscache.com/im/pictures/be5ec43d-245a-4c09-9bb7-a5e1b8eb56b3.jpg?im_w=720",
        name:"Okra",
        price: 6532,
        type:"arctic",
        stars: "4.98",
        carouselPic1:  "https://a0.muscache.com/im/pictures/faf3c924-ac17-4fdb-a00b-9b7a80656034.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/499317b6-96f4-4523-aa10-6faaafacfca1.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-42240030/original/08fade53-5651-4bad-8018-546d16b3193a.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/d9fbb155-c7e8-4b4e-8c98-97bea1c29a6f.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/c5f59d0f-e527-4de8-84e5-7ef3ebd7bd5d.jpg?im_w=720",
        location:"australia",
        pets:false,
    },

    {
        id:"130",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-51835140/original/02f6e85a-a996-44d9-aa7a-f76077517adb.jpeg?im_w=720",
        name:"Susmo",
        price: 6532,
        type:"arctic",
        stars: "4.98",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-51835140/original/99828e3c-bc96-4ea3-89c8-101f1e7de439.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-51835140/original/8bc5cdcf-1526-428d-a74d-90ff7d52eb34.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-51835140/original/652d56ea-9891-414b-80d7-59e93866fb62.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-51835140/original/dcac3c4d-e59c-4997-abed-b903bb3c6ef0.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-51835140/original/38f535ff-f97e-43d6-bc48-71d64241225f.jpeg?im_w=720",
        location:"australia",
        pets:false,
    },

    
    {
        id:"131",
        homeMainPic: "https://a0.muscache.com/im/pictures/30519994-6908-4414-86a8-8c0035e9f8d0.jpg?im_w=720",
        name:"PelkoSenani",
        price: 5896,
        type:"arctic",
        stars: "5.00",
        carouselPic1:  "https://a0.muscache.com/im/pictures/ea26291a-bd03-4dec-a41d-8d0eeb0fb729.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/28ed75f2-74c5-4c1d-8b4f-d7f6cc96e0b4.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/d4abb943-f5fa-4b18-97e2-e8db7fbbf982.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/88c7620c-0c19-476f-ba25-ba5db2c52119.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/69555c3b-2900-42cf-b1e3-804fb1a4914c.jpg?im_w=720",
        location:"brazil",
        pets:true,
    },

    {
        id:"132",
        homeMainPic: "https://a0.muscache.com/im/pictures/0a015d94-ae15-45ed-87b4-62e3d11fae8a.jpg?im_w=720",
        name:"Rovanneni",
        price: 3698,
        type:"arctic",
        stars: "4.80",
        carouselPic1:  "https://a0.muscache.com/im/pictures/9410c4da-9989-42e7-ab2b-65159dde00f8.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-39363663/original/fa8c0298-09f6-4467-9636-31d090df32b2.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-39363663/original/b1b0b5c2-8568-402b-b3b6-fccf7991b5d2.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-39363663/original/79e52ea9-ba5f-4f07-834f-4b9be3d40b56.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-39363663/original/8eae6d24-6bab-4848-8ac9-a711c99301d7.jpeg?im_w=720",
        location:"brazil",
        pets:true,
    },

    {
        id:"133",
        homeMainPic: "https://a0.muscache.com/im/pictures/miso/Hosting-38668181/original/29d312a4-8393-4fd9-a20c-51f0c8df09e5.jpeg?im_w=720",
        name:"Kemij",
        price: 2456,
        type:"arctic",
        stars: "4.65",
        carouselPic1:  "https://a0.muscache.com/im/pictures/b7f50398-fbf8-4f05-8004-c4439fb5d147.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/488c2d9a-b52c-4a4f-8405-db78245f3078.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-38668181/original/3eaea06f-fc96-481c-9324-0c7f9b4df2ed.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-38668181/original/32eac7c6-0d82-46d6-8824-e5d3569d89b9.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/ca907a97-585c-48f2-952b-64791018afc6.jpg?im_w=720",
        location:"brazil",
        pets:true,
    },

    {
        id:"134",
        homeMainPic: "https://a0.muscache.com/im/pictures/b17769d4-059f-46c4-b77e-abe559169085.jpg?im_w=720",
        name:"Rovanmea",
        price: 8965,
        type:"arctic",
        stars: "4.83",
        carouselPic1:  "https://a0.muscache.com/im/pictures/0d45bbde-e910-4b71-b85d-caaf209e29ea.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/6c06b5d4-e738-4287-9dbc-70ddaba42560.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/9426259a-652c-4c5f-ab15-5c09fb78cd6d.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/42b9cd84-5666-4f70-8ae6-4f0124577e27.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/f8b9f2db-05bd-4303-819b-9dd08b74dd4c.jpg?im_w=720",
        location:"brazil",
        pets:false,
    },

    {
        id:"135",
        homeMainPic: "https://a0.muscache.com/im/pictures/505e4aa7-73ea-4287-bbde-64f1b6436fd8.jpg?im_w=720",
        name:"Finerpol",
        price: 4650,
        type:"arctic",
        stars: "New",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-52948173/original/03b6b9e0-8e9b-4e0b-a5a6-b1a98360daa5.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-52948173/original/ca13b983-d227-4392-81d6-8bc316d1f245.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-52948173/original/80d28d89-05b4-4302-9563-a8d936a89707.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-52948173/original/f3babf58-f109-4fa0-8f0c-9be6d3520c30.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-52948173/original/c85c32d2-5c5e-455f-85da-94c73846fbc7.jpeg?im_w=720",
        location:"brazil",
        pets:false,
    },

    {
        id:"136",
        homeMainPic: "https://a0.muscache.com/im/pictures/7809096f-55f0-47c9-b0be-75bbaeec2122.jpg?im_w=720",
        name:"Kussamo",
        price: 3650,
        type:"arctic",
        stars: "4.96",
        carouselPic1:  "https://a0.muscache.com/im/pictures/eff9f074-0276-40e2-b5ff-eba17988f9aa.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/680264a8-d0fd-4c5d-9a73-cf6cb43dd0d3.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/bf412d14-f9dd-432c-8d37-9afe80e2a51a.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/aaac2544-7d47-4358-a401-9243060d889d.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-14837629/original/a8f257f8-e977-4288-afee-425aab22f63a.png?im_w=720",
        location:"brazil",
        pets:false,
        couple:true,

    },

    {
        id:"137",
        homeMainPic: "https://a0.muscache.com/im/pictures/72e3dfea-2b90-4afe-a1bd-1be37e77539a.jpg?im_w=720",
        name:"Quazi",
        price: 7456,
        type:"arctic",
        stars: "4.88",
        carouselPic1:  "https://a0.muscache.com/im/pictures/61e15b47-a563-4348-b891-5106bc4ebb02.jpg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/126374d2-69b6-4695-887f-aeee6345e7f1.jpg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/2a4637ae-4322-4623-9475-aad69250ba90.jpg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/67cde095-c507-4e40-a4ce-499de12e66af.jpg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/60d4058e-98a8-4f30-ba8a-93b101a31c47.jpg?im_w=720",
        location:"brazil",
        pets:false,
        couple:true,

    },

    {
        id:"138",
        homeMainPic: "https://a0.muscache.com/im/pictures/be5ec43d-245a-4c09-9bb7-a5e1b8eb56b3.jpg?im_w=720",
        name:"Aura",
        price: 4500,
        type:"arctic",
        stars: "4.95",
        carouselPic1:  "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/a072b835-1a9f-4189-9493-4706414dd519.jpeg?im_w=720",
        carouselPic2 : "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/825371c6-0b1b-49a8-bca6-61955355b81d.jpeg?im_w=720",
        carouselPic3 : "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/69cc53df-0698-4292-99cc-3e7989fd0e7a.jpeg?im_w=720",
        carouselPic4 : "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/bac67c67-90d2-4cea-a5f4-8e37d677a645.jpeg?im_w=720" ,
        carouselPic5 : "https://a0.muscache.com/im/pictures/miso/Hosting-580103554611229141/original/9e859008-411d-4418-928a-b18a72c34d3d.jpeg?im_w=720",
        location:"brazil",
        pets:false,
        couple:true,

    },


]